import React, { Component } from 'react'
import {getAllUrlParams} from "./UrlParameters"
import { ConstantsNames } from "./Urls"
import { Link } from 'react-scroll'  /* https://www.npmjs.com/package/react-scroll */

export default class Maskyoo extends Component {

    /* MaskyooFunction = () => {

    } */


    render() {

        //console.log(this.props);

        let proj = this.props.pageData.project.info.data;
        const urlQuery = getAllUrlParams(localStorage.getItem('path'));
        const campaign_id = urlQuery.campaign_id ? urlQuery.campaign_id : '';


        return (
            <nav className='projMenuFixed oneBtn'>
                {/* this.props.pageData.project.info.data.maskyoo_api_key.length > 0 */}
                <Link className={this.props.accesStates.motionOffClass==='motionOff' ? '' : 'bounce' }  key={proj.id} activeClass="active" to='goToThis' spy={true} smooth={true} isDynamic={true} offset={-150} >
                לתיאום פגישה &raquo;
                </Link>
               
                { proj.maskyoo_api_key && false ? 
                    <iframe title='showMaskyoo' src={ConstantsNames.maskyooIframe + proj.id + '&campaign_id=' + campaign_id }/> : false
                }
                
            </nav>
        )
    }
}

